/*
* <license header>
*/

import React, { useState, useMemo } from 'react'
import { Grid, minmax, repeat, SearchField, View } from '@adobe/react-spectrum'
import { PageHeaderBanner } from '../shared/PageHeaderBanner'
import { AppCard } from './AppCard'
import { AppAssistant } from '../shared/AppAssistant'
import { useNavigate } from 'react-router-dom'
import { APPS } from '../../data/constants'
import { useFavorites } from '../../context/FavoritesContext'

export const AppBrowserList = () => {
  const navigate = useNavigate()
  const { isFavorite, toggleFavorite } = useFavorites()
  const [filter, setFilter] = useState('')

  const filteredApps = useMemo(() => {
    if (!filter.trim()) return APPS
    const query = filter.trim().toLowerCase()
    return APPS.filter((app) => app.title.toLowerCase().includes(query))
  }, [filter])

  return (
    <View width="100%" minWidth={0} padding="size-400" UNSAFE_style={{ paddingBottom: '2.5rem' }}>
      <PageHeaderBanner
        title="AppBuilder Factory"
        subtitle="AppBuilder Factory App Repository"
      />

      <View padding="size-200" backgroundColor="gray-75" borderWidth="thin" borderColor="gray-300" borderRadius="regular" marginBottom="size-300">
        <SearchField
          aria-label="Search"
          placeholder="Search filter..."
          width="100%"
          value={filter}
          onChange={setFilter}
        />
      </View>

      <Grid
        columns={repeat('auto-fill', minmax('size-3000', '1fr'))}
        autoRows="auto"
        gap="size-200"
        width="100%"
        marginBottom="size-300"
      >
        {filteredApps.map((app) => (
          <AppCard
            key={app.id}
            id={app.id}
            title={app.title}
            description={app.description}
            status={app.status}
            onClick={() => navigate(`/apps/${app.id}`)}
            isFavorite={isFavorite(app.id)}
            onToggleFavorite={toggleFavorite}
          />
        ))}
      </Grid>

      <AppAssistant />
    </View>
  )
}
